import React from "react";
const returnDate = (d) => {
  return new Date(d).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};
const EMailActivity = ({ plans }) => {
  return (
    <>
      {plans.length > 0 ? (
        <table className="plan_table mt-24">
          <thead className="plan_thead activityplan_thead">
            <tr className="plan_thead_tr plan_tr">
              <th className="plan_thead_tr plan_td">Email Subject</th>
              <th className="plan_thead_tr plan_td">Recipient</th>
              <th className="plan_thead_tr plan_td">Profile</th>
              <th className="plan_thead_tr plan_td">Sent at</th>
            </tr>
          </thead>
          <tbody className="plan_tbody">
            {plans.map((plan) => (
              <tr key={plan._id} className="plan_tbody_tr plan_tr">
                <td className="plan_tbody_td plan_td">{plan.subject}</td>
                <td className="plan_tbody_td plan_td">{plan.email[0]}</td>

                <td className="plan_tbody_td plan_td">
                  <div className="d-flex plan_tbody_logo align-items-center">
                    {plan.user ? (
                      <>
                        <img src={plan?.user?.avatar} alt="logo" />
                        <div>
                          <p className="m-0">
                            {plan?.user?.name
                              ? plan?.user?.name
                              : `${plan?.user?.firstname} ${plan?.user?.lastname}`}
                          </p>
                          <p className="m-0 mt-8">{`${plan?.user?.email}`}</p>
                        </div>
                      </>
                    ) : (
                      "Not Found"
                    )}
                  </div>
                </td>
                <td className="plan_tbody_td plan_td">
                  {returnDate(plan?.createdAt)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <h2>No Plans</h2>
      )}
    </>
  );
};

export default EMailActivity;
